package co.torvus.web.sections

import co.torvus.web.classes
import co.torvus.web.content.services
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h3
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.section
import web.cssom.ClassName
import web.dom.ElementId

val ServicesSection = FC<Props> {
    section {
        className = ClassName("services section")
        id = ElementId("services")

        services.forEachIndexed { index, service ->
            val light = index % 2 == 1
            div {
                className = classes(
                    "service-row",
                    if (light) "light" else null,
                    if (light) "reverse" else null,
                )
                div {
                    className = ClassName("service-row-inner")
                    div {
                        className = ClassName("service-card")
                        img {
                            src = service.image
                            alt = service.title
                        }
                    }
                    div {
                        className = ClassName("service-text")
                        h3 {
                            className = ClassName("service-title")
                            +service.title
                        }
                        p {
                            className = ClassName("service-body")
                            +service.body
                        }
                    }
                }
            }
        }
    }
}
